export const menuList = [
  {
    id: 1,
    title: "产品中心",
    children: [
      { 
        key: "/search",
        title: "产品信息" 
      },
      {
        key: "/product_vedio", 
        title: "产品视频" 
      },
      { 
        key: "/SecurityCheck", 
        title: "防伪验证" 
      }
    ]
  },
  {
    id: 2,
    title: "团购定制",
    children: [
      {
        key: "/product_customize",
        title: "产品定制"
      },
      {
        key: "/space_customize",
        title: "空间定制"
      }
    ]
  },
  {
    id: 3,
    title: "雅集茶文化",
    children: [
      { 
        key: "/tea_appreciation", 
        title: "茗茶鉴赏" 
      },
      { 
        key: "/beauty_analysis", 
        title: "美器解析" 
      }
    ]
  },
  {
    id: 4,
    title: "走进雅集",
    children: [
      { 
        key: "/brand_intro", 
        title: "品牌介绍" 
      },
      {
        key: "/development",
        title: "发展简史"
      },
      {
        key: "/culture",
        title: "企业文化"
      },
      {
        key: "/brand_video",
        title: "品牌视频"
      },
      {
        key: "/dynamic",
        title: "企业动态"
      }
    ]
  },
  {
    id: 5,
    title: "联系雅集",
    children: [
      {
        key: "/contact",
        title: "雅集在线"
      },
      {
        key: "/recruitment",
        title: "人才招聘"
      }
    ]
  }
];

export const headerMenuType = {
  boiler: "/boiler",
  janeTeaWare: "/janeTeaWare",
  glass: "/glass",
  teaCeremonyAlbum: "/teaCeremonyAlbum",
  goodThings: "/goodThings"
};

export const headerMenuList = [
  {
    key: headerMenuType.boiler,
    title: "煮泡器"
  },
  {
    key: headerMenuType.janeTeaWare,
    title: "简茶器"
  },
  {
    key: headerMenuType.glass,
    title: "玻璃杯"
  },
  {
    key: headerMenuType.teaCeremonyAlbum,
    title: "茶道辑"
  },
  {
    key: headerMenuType.goodThings,
    title: "茶美物"
  }
];
